import { createSlice } from '@reduxjs/toolkit'

import { Zone } from '../../shared/types/zone'
import { Coordinates } from '../../shared/types'
import { checkZones } from './zoneDetectorThunks'

const initialState = {
  userCoords: <Coordinates | null>null,
  data: <Zone[] | null>null,
  loading: false,
  error: <string | null>null,
}

const zonesDetectorSlice = createSlice({
  name: 'zone',
  initialState,
  reducers: {
    resetZonesDetector: () => initialState,
    clearZoneDetectorError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkZones.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(checkZones.fulfilled, (state, action) => {
        state.loading = false
        state.userCoords = action.payload?.userCoords
        state.data = action.payload?.zones?.length
          ? (action.payload.zones as Zone[])
          : null
      })
      .addCase(checkZones.rejected, (state, action) => {
        // TODO: fix error response
        state.data = null
        state.error = action?.payload?.message ?? 'Unknown error'
        // if (action.payload) {
        //   state.data = null
        //   state.error = action.payload.message
        //   // Treat 404 as "no data" instead of an error
        //   if (action.payload.status === 404) {
        //     state.data = null
        //   }
        // } else {
        //   state.error = action.error.message ?? 'Unknown error'
        // }
      })
  },
})

// Export the reset action so you can dispatch it
export const { resetZonesDetector, clearZoneDetectorError } =
  zonesDetectorSlice.actions

// Export the reducer to be used in the store
export default zonesDetectorSlice.reducer
